import React from "react";
import { Routes, Route } from "react-router-dom";

import { BaseUrlProvider } from './context/AppContext';

// 404 PAGE
import Error from "./components/notfound/Error";

// PUBLIC SCREENS
import Home from "./screens/customer/home/Home";
import About from "./screens/customer/about/About";
import Services from "./screens/customer/services/Services";
import Events from "./screens/customer/events/Events";
import Contact from "./screens/customer/contact/Contact";
import Blog from "./screens/customer/blog/Blog";
import BlogDetail from "./screens/customer/blog/BlogDetail";
import Venues from "./screens/customer/venues/Venues";
import Packages from "./screens/customer/packages/Packages";
import VenueDetailpage from "./screens/customer/venues/VenueDetailpage";
import BookingDetails from "./screens/customer/venues/BookingDetails";
import PackagesDetail from "./screens/customer/packages/PackagesDetail";

// CUSTOMER DASHBOARD SCREENS
import CustomerLogin from "./screens/customer/controlPanel/auth/CustomerLogin";
import CustomerRegister from "./screens/customer/controlPanel/auth/CustomerRegistor";
import CustomerLayout from "./layouts/customer/CustomerLayout";
import CustomerDashboard from "./screens/customer/controlPanel/dashboard/CustomerDashboard";
import MyEvents from "./screens/customer/controlPanel/dashboard/MyEvents";
import MyBookings from "./screens/customer/controlPanel/dashboard/MyBookings";
import Invitations from "./screens/customer/controlPanel/dashboard/Invitations";
import Payments from "./screens/customer/controlPanel/dashboard/Payments";
import CustomerSettings from "./screens/customer/controlPanel/dashboard/CustomerSettings";
import CustomerNotifications from "./screens/customer/controlPanel/dashboard/CustomerNotifications";
import CustomerProfile from "./screens/customer/controlPanel/dashboard/CustomerProfile";
import HelpandSupport from "./screens/customer/controlPanel/dashboard/HelpandSupport";
import CustomerChat from "./screens/customer/controlPanel/dashboard/CustomerChat";
import AIPlannar from "./screens/customer/controlPanel/dashboard/AIPlannar";

// ADMIN SCREENS
import Dashboard from "./screens/admin/dashboard/Dashboard";
import Login from "./screens/admin/auth/Login";
import AdminProfile from "./screens/admin/dashboard/admin profile/AdminProfile";
import Subadmin from "./screens/admin/dashboard/Subadmin";
import SupportTickets from "./screens/admin/dashboard/SupportTickets";
import Settings from "./screens/admin/dashboard/setting/Settings";
import Notifications from "./screens/admin/dashboard/notifications/Notifications";
import AdminBlogs from "./screens/admin/dashboard/blogs/AdminBlogs";
import ManagePackages from "./screens/admin/dashboard/packages/ManagePackages";
import ServicesManagement from "./screens/admin/dashboard/services/ServicesManagement";
import InvitationsTemplate from "./screens/admin/dashboard/invitations/InvitationsTemplate";
import EventTypes from "./screens/admin/dashboard/eventtype/EventTypes";
import AdminChat from "./screens/admin/dashboard/adminchat/AdminChat";

// User Management
import Allusers from "./screens/admin/dashboard/user management/AllUsers";

// Event Management
import AllEvents from "./screens/admin/dashboard/Event management/AllEvents";
import UpComingEvents from "./screens/admin/dashboard/Event management/UpcomingEvents";
import CompletedEvents from "./screens/admin/dashboard/Event management/CompletedEvents";

// Venue Management
// import AddVenues from "./screens/admin/dashboard/Venue management/AddVenues";
// import BookingRequest from "./screens/admin/dashboard/Venue management/BookingRequest";
import VenuesList from "./screens/admin/dashboard/Venue management/VenuesList";

// Booking Management
import Bookingmanagement from "./screens/admin/dashboard/booking/Bookingmanagement";


// Payment Management
import PaymentHistory from "./screens/admin/dashboard/Payment management/PaymentHistory";
import RefundRequests from "./screens/admin/dashboard/Payment management/RefundRequests";

// Reports
// import Reports from "./screens/admin/dashboard/Reports and analytics/Reports";

// STYLES
import "./assets/css/fonts/fontStyles.css";
import "./App.css";


function App() {
  return (
    <BaseUrlProvider>
      <Routes>

        {/* CUSTOMER PUBLIC ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />
        <Route path="/venues" element={<Venues />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/venue-details" element={<VenueDetailpage />} />
        <Route path="/bookingdetails" element={<BookingDetails />} />
        <Route path="/packagesdetail" element={<PackagesDetail />} />

        {/* CUSTOMER DASHBOARD ROUTES */}
        <Route path="/customer/login" element={<CustomerLogin />} />
        <Route path="/customer/register" element={<CustomerRegister />} />
        <Route path="/customerlayout" element={<CustomerLayout />} />
        <Route path="/customer/dashboard" element={<CustomerDashboard />} />
        <Route path="/customer/my-events" element={<MyEvents />} />
        <Route path="/customer/my-bookings" element={<MyBookings />} />
        <Route path="/customer/invitations" element={<Invitations />} />
        <Route path="/customer/payments" element={<Payments />} />
        <Route path="/customer/settings" element={<CustomerSettings />} />
        <Route path="/customer/notifications" element={<CustomerNotifications />} />
        <Route path="/customer/profile" element={<CustomerProfile />} />
        <Route path="/customer/helpandsupport" element={<HelpandSupport />} />
        <Route path="/customer/chat" element={<CustomerChat />} />
        <Route path="/customer/ai-plannar" element={<AIPlannar />} />

        {/* ADMIN ROUTES */}
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin-dashboard" element={<Dashboard />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
        <Route path="/admin/sub-admin" element={<Subadmin />} />
        <Route path="/admin/supporttickets" element={<SupportTickets />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin/notifications" element={<Notifications />} />
        <Route path="/admin/blogs" element={<AdminBlogs />} />
        <Route path="/admin/packages" element={<ManagePackages />} />
        <Route path="/admin/services" element={<ServicesManagement />} />
        <Route path="/admin/invitationstemplate" element={<InvitationsTemplate />} />
        <Route path="/admin/event-type" element={<EventTypes />} />
        <Route path="/admin/chat" element={<AdminChat />} />

        {/* ADMIN USER MANAGEMENT */}
        <Route path="/admin/users/all" element={<Allusers />} />

        {/* ADMIN EVENT MANAGEMENT */}
        <Route path="/admin/events/all" element={<AllEvents />} />
        <Route path="/admin/events/upcoming" element={<UpComingEvents />} />
        <Route path="/admin/events/completed" element={<CompletedEvents />} />

        {/* ADMIN VENUE MANAGEMENT */}
        {/* <Route path="/admin/venues/add" element={<AddVenues />} /> */}
        <Route path="/admin/venues/list" element={<VenuesList />} />
        {/* <Route path="/admin/venues/requests" element={<BookingRequest />} /> */}

        {/* ADMIN BOOKING MANAGEMENT */}
        <Route path="/admin/bookings/bookingmanagement" element={<Bookingmanagement />} />
        

        {/* ADMIN PAYMENT MANAGEMENT */}
         <Route path="/admin/payments/history" element={<PaymentHistory />} />
        <Route path="/admin/payments/refunds" element={<RefundRequests />} /> 

        {/* ADMIN REPORTS */}
        {/* <Route path="/admin/reports" element={<Reports />} /> */}

        {/* 404 PAGE */}
        <Route path="*" element={<Error />} />

      </Routes>
    </BaseUrlProvider>
  );
}

export default App;